import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {ReservationService} from '../api/reservation.service';
import {CheckInFlowService} from '../services/check-in-flow.service';
import {catchError, map, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {hasCompletedAdultCheckIns} from '../../shared/models/check-in-flow.model';

export const reservationHasAdultCompletedCheckinsGuard: CanActivateFn = () => {
  const reservationService = inject(ReservationService);
  const checkInFlowService = inject(CheckInFlowService);
  const router = inject(Router);

  return reservationService.getReservation().pipe(
    mergeMap((reservation) => {
      return checkInFlowService.get(reservation).pipe(
        map(checkInFlowData => {
          if (hasCompletedAdultCheckIns(checkInFlowData)) {
            return true;
          } else {
            return router.parseUrl('/');
          }
        })
      )
    }),
    catchError(() => of(router.parseUrl('/')))
  );
}
